import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';
import { memo } from 'react';

import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';
import snakeCaseToTitleCase from '@/utils/snakeToTitleCase';

// const dataExample = {
//   reason: 'test',
//   reference_for: 'rachel+ref2@joinaffect.com',
//   referred_at: '2023-06-14T10:46:37.000-04:00',
//   referred_by: 'rachel+ref@joinaffect.com',
//   role_of_referrer: 'Medical Provider',
//   source: 'Other'
// };

const ReferralCreatedEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { action, actor, data, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faHandHoldingHeart}
          iconClassName="text-lime-700"
          title={snakeCaseToTitleCase(action ?? '')}
        />

        {data?.referred_by && <div>By: {data.referred_by}</div>}
        {data?.source && <div>Source: {data.source}</div>}
        {data?.role_of_referrer && <div>Role of referrer: {data.role_of_referrer}</div>}
        {data?.reason && (
          <div>
            Reason: <span className="mp-sensitive">{data.reason}</span>
          </div>
        )}
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(ReferralCreatedEvent);
